import React from 'react';
import { toPercent } from 'pano-utils';
import { useStore } from 'effector-react';
import { type HSIconSystem, HSIconType } from '@types';
import Slider from '@components/Slider';
import Button from '@components/Button';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import WidgetItem from '@components/PlayerWidgets/WidgetItem';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import EdgeRow from './EdgeRow';
import hotspotIconDefault from '../utils/hotspotIconDefault';

const MIN = 0.01;
const MAX = 1;
const STEP = 0.01;

function SysIconWidget() {
  const { hotspot, isBatch, batchHotspots } = useStore($editingHotspot)!;
  const icon = hotspot.icon as HSIconSystem;

  const handleScaleChange = (val: number) => {
    $editingHotspotApi.update((draft) => {
      (draft.icon as HSIconSystem).scaleX = val;
      (draft.icon as HSIconSystem).scaleY = val;
    });
    if (!isBatch) {
      MainPlayer.get()?.updateImageFrameHotspot({
        id: hotspot.id,
        scaleX: val,
        scaleY: val,
      });
    } else {
      (batchHotspots ?? []).forEach((item) => {
        MainPlayer.get()?.updateImageFrameHotspot({
          id: item.id,
          scaleX: val,
          scaleY: val,
        });
      });
    }
  };

  const handleReset = () => {
    const { scaleX, scaleY, edge } = hotspotIconDefault({
      type: HSIconType.system,
    }) as HSIconSystem;
    $editingHotspotApi.update((draft) => {
      (draft.icon as HSIconSystem).scaleX = scaleX;
      (draft.icon as HSIconSystem).scaleY = scaleY;
      (draft.icon as HSIconSystem).edge = edge;
    });
    if (!isBatch) {
      MainPlayer.get()?.updateImageFrameHotspot({
        id: hotspot.id,
        scaleX,
        scaleY,
        edge,
      });
    } else {
      (batchHotspots ?? []).forEach((item) => {
        MainPlayer.get()?.updateImageFrameHotspot({
          id: item.id,
          scaleX,
          scaleY,
          edge,
        });
      });
    }
  };

  return (
    <WidgetItem type="sysIcon" title="图标高级设置">
      <WidgetRow>
        <Slider
          value={icon.scaleX}
          min={MIN}
          max={MAX}
          valToString={(val) => toPercent(val, 0)}
          onChange={handleScaleChange}
        >
          <Slider.Header title="缩放：" />
          <Slider.Bar step={STEP} />
          <Slider.Control step={STEP} />
        </Slider>
      </WidgetRow>
      <WidgetRow>
        <EdgeRow />
      </WidgetRow>
      <Button className="w-full" onClick={handleReset}>
        重置设置
      </Button>
    </WidgetItem>
  );
}

export default SysIconWidget;
